import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatSidenav, MatSidenavContainer, MatSidenavContent } from '@angular/material/sidenav';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { map } from 'rxjs';

interface NavItem {
  label: string;
  route: string;
  icon: string;
}

// Matches the Tailwind `md` screen (960px) from tailwind.config.ts.
const DESKTOP_QUERY = '(min-width: 960px)';

@Component({
  selector: 'rms-layout',
  templateUrl: './layout.component.html',
  imports: [
    MatSidenavContainer,
    MatSidenav,
    MatSidenavContent,
    MatIcon,
    MatIconButton,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    TranslatePipe,
  ],
})
export class LayoutComponent {
  public readonly navItems: NavItem[] = [{ label: 'layout.nav.home', route: '/home', icon: 'mat:home' }];

  private readonly breakpointObserver = inject(BreakpointObserver);

  public readonly isDesktop = toSignal(
    this.breakpointObserver.observe(DESKTOP_QUERY).pipe(map((state) => state.matches)),
    { initialValue: true }
  );
  public readonly sidenavMode = computed(() => (this.isDesktop() ? 'side' : 'over'));
}
